import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown"]
  
  connect() {
    console.log("Password reset controller connected")
    this.setupDropdownHandlers()
  }
  
  setupDropdownHandlers() {
    // Find all password reset dropdown triggers
    const triggers = document.querySelectorAll('.password-reset-dropdown-trigger')
    
    console.log(`Found ${triggers.length} password reset dropdown triggers`)
    
    triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        
        console.log('Password reset trigger clicked')
        
        const dropdownId = trigger.getAttribute('data-dropdown')
        console.log('Looking for dropdown with ID:', dropdownId)
        const dropdown = document.getElementById(dropdownId)
        
        if (dropdown) {
          console.log('Dropdown found, toggling visibility')
          // Toggle dropdown visibility
          this.toggleDropdown(dropdown)
          
          // Close dropdown when clicking outside
          document.addEventListener('click', this.closeDropdownOutside.bind(this, dropdown), { once: true })
        } else {
          console.error('Dropdown not found with ID:', dropdownId)
        }
        
        return false
      })
    })
    
    // Handle password reset link clicks
    const resetLinks = document.querySelectorAll('.password-reset-link')
    resetLinks.forEach(link => {
      link.addEventListener('click', this.handlePasswordReset.bind(this))
    })
  }
  
  toggleDropdown(dropdown) {
    console.log('toggleDropdown called for:', dropdown.id)
    if (dropdown.classList.contains('show')) {
      console.log('Hiding dropdown')
      dropdown.classList.remove('show')
      dropdown.style.display = 'none'
    } else {
      console.log('Showing dropdown')
      // Close all other dropdowns first
      document.querySelectorAll('.f-dropdown').forEach(dd => {
        dd.classList.remove('show')
        dd.style.display = 'none'
      })

      dropdown.classList.add('show')
      dropdown.style.display = 'block'
      dropdown.style.position = 'absolute'
      dropdown.style.zIndex = '1000'
      dropdown.style.backgroundColor = 'white'
      dropdown.style.border = '1px solid #ddd'
      dropdown.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)'
      dropdown.style.margin = '0'
      dropdown.style.padding = '0'

      // Position the dropdown directly below the trigger button
      // Find the trigger button that opened this dropdown
      const triggers = document.querySelectorAll('.password-reset-dropdown-trigger')
      let trigger = null
      triggers.forEach(t => {
        if (t.getAttribute('data-dropdown') === dropdown.id) {
          trigger = t
        }
      })
      if (trigger) {
        console.log('Positioning dropdown below trigger')
        const rect = trigger.getBoundingClientRect()
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
        dropdown.style.top = (rect.bottom + scrollTop) + 'px'
        dropdown.style.left = (rect.left + scrollLeft) + 'px'
        dropdown.style.minWidth = rect.width + 'px'
        console.log('Dropdown positioned at:', dropdown.style.top, dropdown.style.left)
        console.log('Dropdown computed style:', window.getComputedStyle(dropdown).display, window.getComputedStyle(dropdown).visibility, window.getComputedStyle(dropdown).opacity)
        console.log('Dropdown bounding rect:', dropdown.getBoundingClientRect())
      } else {
        console.error('Could not find trigger for dropdown:', dropdown.id)
      }
    }
  }
  
  closeDropdownOutside(dropdown, e) {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('show')
      dropdown.style.display = 'none'
    }
  }
  
  handlePasswordReset(e) {
    const link = e.currentTarget
    const userEmail = link.getAttribute('data-user-email')
    const confirmMessage = link.getAttribute('data-confirm')
    
    if (confirmMessage && !confirm(confirmMessage)) {
      e.preventDefault()
      return false
    }
    
    // Let Rails UJS handle the actual request
    console.log(`Sending password reset to: ${userEmail}`)
  }
}
